import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './index.css';

// Redirect CloudFront URL to canonical domain in production
const CANONICAL_DOMAIN = 'asisecurity.corporacionasi.com';
if (
  import.meta.env.PROD &&
  window.location.hostname !== CANONICAL_DOMAIN &&
  window.location.hostname !== 'localhost'
) {
  window.location.replace(
    `https://${CANONICAL_DOMAIN}${window.location.pathname}${window.location.search}${window.location.hash}`
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(console.error);
  });
}
